import React, { useMemo } from 'react'

import { generateId } from '../../../utils/helpers'
import { CheckBoxProps } from '../../../types/common-types'

import styles from './RadioInput.module.scss'
import cn from 'classnames'

export default function RadioInput({
  lang,
  label,
  className,
  onChange,
  value,
  name,
  testId
}: CheckBoxProps) {
  return (
    <div className={cn(styles.radioInputBox, className)}>
      <input
        data-test-id={testId}
        id={name}
        name={name}
        type="radio"
        onChange={() => {
          onChange(!value)
        }}
        checked={value}
      />
      <label htmlFor={name}>
        {label[lang]}
      </label>
    </div>
  )
}
